import { render, staticRenderFns } from "./AgTable.vue?vue&type=template&id=6e6d5cc3"
import script from "./AgTable.vue?vue&type=script&lang=js"
export * from "./AgTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports